<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat>
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Properties</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedProperties ? allProperties : allProperties.filter(b => b.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Property</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col cols="4" class="">
            <v-text-field
              v-model="property.def.PropertyCode"
              dense filled
              color="#2A353D"
              label="Property Code"
              required
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 10) || 'field must be less than 10 characters'
              ]"
            ></v-text-field>

            <v-text-field
              v-model="property.def.PropertyName"
              dense filled
              color="#2A353D"
              label="Property Name"
              required
              placeholder="----"
              :rules="TextFieldRules"
            ></v-text-field>

            <v-text-field
              :value="property.def.DateDefined"
              label="Date Defined"
              append-icon="mdi-calendar-month"
              readonly
              dense filled color="#2A353D"
            ></v-text-field>

            <v-select
              filled dense
              v-model="property.def.PropertyStatusID"
              :items="allPropertyStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="PropertyStatusCode"
              item-value="PropertyStatusID"
              placeholder="----"
              label="Status"
            ></v-select>

            <v-select
              filled dense
              v-model="property.def.FundClassId"
              :items="fundClasses"
              item-text="Value"
              item-value="ID"
              placeholder="----"
              label="Fund Class"
            ></v-select>
          </v-col>

          <v-col cols="8" class="pt-3">
            <v-tabs
              class="elevation-12"
              fixed-tabs
            >
              <v-tab >General</v-tab>
              <v-tab-item>
                <v-row class="pt-3 ml-1 mr-1">
                  <v-col class="pb-0">
                    <v-card class="elevation-0 px-5">
                      <span class="caption">Physical Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="property.def.Physical_Address_1"
                        required
                        :rules="TextFieldRules"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="property.def.Physical_Address_2"
                        required
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="property.def.Physical_Address_3"
                        required
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="property.def.Physical_CountryID"
                        :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="CountryName"
                        item-value="CountryId"
                        label="Country"
                        :rules="TextFieldRules"
                      ></v-select>
                      <v-select
                        filled dense
                        v-model="property.def.Physical_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0 && a.CountryId == property.def.Physical_CountryID)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>

                  <v-col class="pt-6">
                    <v-text-field
                      v-model="property.def.CertificateNumber"
                      dense filled
                      color="#2A353D"
                      label="Certificate Number"
                      required
                      placeholder="----"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      v-model="property.def.TotalUnits"
                      dense filled type="number"
                      color="#2A353D"
                      label="Total Units"
                      required
                      placeholder="----"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-row>
                      <v-col class="py-0">
                        <v-text-field
                          v-model="property.def.UnitPrice"
                          dense filled type="number"
                          color="#2A353D"
                          label="Unit Price"
                          required
                          placeholder="----"
                          :rules="TextFieldRules"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 col-5">
                        <v-select
                          filled dense
                          v-model="property.def.CurrencyID"
                          :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                          item-text="CurrencyCode"
                          item-value="CurrencyID"
                          placeholder="----"
                          label="Currency"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-select
                      filled dense
                      v-model="property.def.PropertyTypeID"
                      :items="allPropertyTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="PropertyType"
                      item-value="PropertyTypeID"
                      placeholder="----"
                      label="Property Type"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab >Holders</v-tab>
              <v-tab-item>
                <v-data-table
                  :headers="holders_headers"
                  :fixed-header="true"
                  :height="276"
                  :items="property.holders"
                  disable-pagination
                  hide-default-footer
                  class="mb-2"
                >
                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="grey--text caption font-weight-normal">Add Property Holders</v-toolbar-title>
                      <v-spacer/>
                      <v-btn class="text-right" @click="NewHolder(property.holders)" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.HolderID="{ item }">
                    <v-select
                      background-color="#ffffff00"
                      v-model="item.HolderID"
                      :items="allCounterparties.filter(a => a.IsPropertyHolder == true && a.CheckerID != 0 && a.RejectionID == 0)"
                      :menu-props="{ top: true, offsetY: true }"
                      item-text="CounterPartyName"
                      item-value="CounterPartyID"
                      :rules="TextFieldRules"
                      hide-details solo flat class="ma-0 pa-0"
                      placeholder="----" dense
                    ></v-select>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon small @click="removeHolder(item, property.holders)">mdi-close</v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab >Management</v-tab>
              <v-tab-item class="py-11 px-4">
                <v-select
                  filled dense
                  v-model="property.def.ManagerID"
                  :items="allCounterparties.filter(a => a.IsPropertyManager == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  label="Property Manager"
                ></v-select>
                <v-select
                  filled dense
                  v-model="property.def.PromoterID"
                  :items="allCounterparties.filter(a => a.IsPropertyPromoter == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  label="Property Promoter"
                ></v-select>
                <v-select
                  filled dense
                  v-model="property.def.TrusteeID"
                  :items="allCounterparties.filter(a => a.IsPropertyTrustee == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  label="Property Trustee"
                ></v-select>
              </v-tab-item>
            </v-tabs>

            <div class="text-right mt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
            </div>
          </v-col>
        </v-row>

      <v-divider class="mt-0"/>
      </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="d-flex flex-row grey--text subtitle-1 font-weight-normal">code: {{currentProperty.PropertyCode.toUpperCase()}}</v-toolbar-title>
            <v-spacer/>
            <span class="mr-2 grey--text caption font-weight-normal">maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentProperty.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span v-if="currentProperty.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentProperty.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span class="ml-2 grey--text caption font-weight-normal">last user: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentProperty.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col cols="4" class="">
            <v-text-field
              v-model="currentProperty.PropertyCode"
              dense filled
              color="#2A353D"
              label="Property Code"
              required
              :readonly="view"
              placeholder="----"
              :rules="[
                v => !!v || 'field is required',
                v => (v && v.length <= 10) || 'field must be less than 10 characters'
              ]"
            ></v-text-field>

            <v-text-field
              v-model="currentProperty.PropertyName"
              dense filled
              color="#2A353D"
              label="Property Name"
              required
              :readonly="view"
              placeholder="----"
              :rules="TextFieldRules"
            ></v-text-field>

            <v-text-field
              :value="currentProperty.DateDefined"
              label="Date Defined"
              append-icon="mdi-calendar-month"
              readonly
              dense filled color="#2A353D"
            ></v-text-field>

            <v-select
              filled dense
              v-model="currentProperty.PropertyStatusID"
              :items="allPropertyStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="PropertyStatusCode"
              item-value="PropertyStatusID"
              placeholder="----"
              :readonly="view"
              label="Status"
            ></v-select>

            <v-select
              filled dense
              v-model="currentProperty.FundClassId"
              :items="fundClasses"
              item-text="Value"
              item-value="ID"
              placeholder="----"
              :readonly="view"
              label="Fund Class"
            ></v-select>
          </v-col>

          <v-col cols="8" class="pt-3">
            <v-tabs
              class="elevation-12"
              fixed-tabs
            >
              <v-tab >General</v-tab>
              <v-tab-item>
                <v-row class="pt-3 ml-1 mr-1">
                  <v-col class="pb-0">
                    <v-card class="elevation-0 px-5">
                      <span class="caption">Physical Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentProperty.Physical_Address_1"
                        required
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentProperty.Physical_Address_2"
                        required
                        :readonly="view"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentProperty.Physical_Address_3"
                        required
                        :readonly="view"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="currentProperty.Physical_CountryID"
                        :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="CountryName"
                        item-value="CountryId"
                        label="Country"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                      <v-select
                        filled dense
                        v-model="currentProperty.Physical_CityID"
                        :items="allCities.filter(a => a.CheckerID != 0 && a.RejectionID == 0 && a.CountryId == currentProperty.Physical_CountryID)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>

                  <v-col class="pt-6">
                    <v-text-field
                      v-model="currentProperty.CertificateNumber"
                      dense filled
                      color="#2A353D"
                      label="Certificate Number"
                      required
                      placeholder="----"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      v-model="currentProperty.TotalUnits"
                      dense filled type="number"
                      color="#2A353D"
                      label="Total Units"
                      required
                      placeholder="----"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>

                    <v-row>
                      <v-col class="py-0">
                        <v-text-field
                          v-model="currentProperty.UnitPrice"
                          dense filled type="number"
                          color="#2A353D"
                          label="Unit Price"
                          required
                          placeholder="----"
                          :readonly="view"
                          :rules="TextFieldRules"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 col-5">
                        <v-select
                          filled dense
                          v-model="currentProperty.CurrencyID"
                          :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                          item-text="CurrencyCode"
                          item-value="CurrencyID"
                          placeholder="----"
                          :readonly="view"
                          label="Currency"
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-select
                      filled dense
                      v-model="currentProperty.PropertyTypeID"
                      :items="allPropertyTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="PropertyType"
                      item-value="PropertyTypeID"
                      placeholder="----"
                      label="Property Type"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab >Holders</v-tab>
              <v-tab-item>
                <v-data-table
                  :headers="holders_headers"
                  :fixed-header="true"
                  :height="276"
                  :items="currentProperty.holders"
                  disable-pagination
                  hide-default-footer
                  class="mb-2"
                >
                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="grey--text caption font-weight-normal">Add Property Holders</v-toolbar-title>
                      <v-spacer/>
                      <v-btn v-if="!view" class="text-right" @click="NewHolder(currentProperty.holders)" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.HolderID="{ item }">
                    <v-select
                      background-color="#ffffff00"
                      v-model="item.HolderID"
                      :items="allCounterparties.filter(a => a.IsPropertyHolder == true && a.CheckerID != 0 && a.RejectionID == 0)"
                      :menu-props="{ top: true, offsetY: true }"
                      item-text="CounterPartyName"
                      item-value="CounterPartyID"
                      :rules="TextFieldRules"
                      hide-details solo flat class="ma-0 pa-0"
                      :readonly="view"
                      placeholder="----" dense
                    ></v-select>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon v-if="!view" small @click="removeHolder(item, currentProperty.holders)">mdi-close</v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab >Management</v-tab>
              <v-tab-item class="py-11 px-4">
                <v-select
                  filled dense
                  v-model="currentProperty.ManagerID"
                  :items="allCounterparties.filter(a => a.IsPropertyManager == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  :readonly="view"
                  label="Property Manager"
                ></v-select>
                <v-select
                  filled dense
                  v-model="currentProperty.PromoterID"
                  :items="allCounterparties.filter(a => a.IsPropertyPromoter == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  :readonly="view"
                  label="Property Promoter"
                ></v-select>
                <v-select
                  filled dense
                  v-model="currentProperty.TrusteeID"
                  :items="allCounterparties.filter(a => a.IsPropertyTrustee == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  :readonly="view"
                  label="Property Trustee"
                ></v-select>
              </v-tab-item>
            </v-tabs>

            <div class="text-right mt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>          
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedProperties" @click="showCreate(); closeEdit(); property.def.DateDefined = currentSystemDate.DayDate" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedProperties" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Property.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Property.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedProperties" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedProperties" @click="confirmedProperties = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedProperties && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="updateStatus(item, true)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedProperties && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveProperty(item, index); rejectionDialog = true"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedProperties"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveProperty(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActiveProperty(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-icon
        :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
        color="#2A353D" @click="setActiveProperty(item, index); deleteDialog = true"
      >
       mdi-trash-can-outline
      </v-icon>
    </template>

    <template v-slot:item.TotalValue="{ item }">
      {{ Number(item.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
    </template>

    <template v-slot:item.MaturityDate="{ item }">
      {{ item.MaturityDate | moment("DD/MM/YYYY") }}
    </template>

    <template v-slot:item.BondInvestmentTypeID="{ item }">
      {{ allBondInvestmentTypes.filter(a => a.BondInvestmentTypeID == item.BondInvestmentTypeID).map(a => a.BondInvestmentTypeDescription)[0] }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedProperties: true,
      permitted: null,
      permitted_dialog: true,
      edit: false,
      create: false,
      view: false,
      rejectionDialog: false,
      deleteDialog: false,
      RejectionStatus: 0,
      message: '',
      search: '',
      valid: true,
      currentProperty: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Code',
          align: 'start',
          sortable: true,
          value: 'PropertyCode'
        },
        { text: 'Name', value: 'PropertyName', sortable: false },
        { text: 'Certificate Number', value: 'CertificateNumber', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      holders_headers: [
        {
          text: 'Holders',
          align: 'start',
          sortable: true,
          value: 'HolderID'
        },
        { value: 'action', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      property: {
        def: {},
        holders: []
      },
      submitted: false,
      fundClasses: [
        {ID: 1, Value: 'Open Ended'},
        {ID: 2, Value: 'Close Ended'}
      ]
    }
  },

  computed: {
    ...mapGetters([
      "allProperties",
      "allPropertyStatuses",
      "allPropertyTypes",
      "allCities",
      "allCountries",
      "allCounterparties",
      "allApplicationDefaults",
      "currentSystemDate",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings",
      "allCurrencies"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 309).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 309).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 309).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 309).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {

  },

  created(){

  },

  methods: {
    ...mapActions([
      "createProperty",
      "updatePropertyStatus",
      "updateProperty",
      "deleteProperty"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.property.def.ValuationDate = this.currentSystemDate.DayDate,
        this.property.def.MarketValue = 0,
        this.property.def.MakerID = this.currentUser.SecurityUserID,
        this.property.def.CheckerID = this.CheckerID,
        this.property.def.LastUserID = this.currentUser.SecurityUserID,

        this.createProperty(this.property)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newProperty',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    updateStatus(item, status) {
      this.message = '';
      this.loading = true;

      if(status == true){
        item.CheckerID = this.currentUser.SecurityUserID,
        item.LastUserID = this.currentUser.SecurityUserID,
        item.CheckDate = new Date(),
        item.updatedAt = new Date(),
        item.RejectionID = this.RejectionStatus,
        item.IsConfirmation = status,

        this.updatePropertyStatus(item)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updProperty',
            data: item
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      } else {
        this.currentProperty.CheckerID = this.currentUser.SecurityUserID,
        this.currentProperty.LastUserID = this.currentUser.SecurityUserID,
        this.currentProperty.CheckDate = new Date(),
        this.currentProperty.updatedAt = new Date(),
        this.currentProperty.RejectionID = this.RejectionStatus,
        this.currentProperty.IsConfirmation = status,

        this.updatePropertyStatus(this.currentProperty)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updProperty',
            data: this.currentProperty
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        if(this.currentProperty.CheckerID == 0){

          this.currentProperty.MakerID = this.currentUser.SecurityUserID,
          this.currentProperty.CheckerID = 0,
          this.currentProperty.CheckDate = null,
          this.currentProperty.LastUserID = this.currentUser.SecurityUserID,
          this.currentProperty.RejectionID = this.RejectionStatus,

          this.updateProperty(this.currentProperty)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updProperty',
              data: this.currentProperty
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          this.currentProperty.MakerID = this.currentUser.SecurityUserID,
          this.currentProperty.MakeDate = new Date(),
          this.currentProperty.CheckerID = 0,
          this.currentProperty.CheckDate = null,
          this.currentProperty.LastUserID = this.currentUser.SecurityUserID,
          this.currentProperty.RejectionID = this.RejectionStatus,

          this.updateProperty(this.currentProperty)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updProperty',
              data: this.currentProperty
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      }
    },

    deleteItem() {
      this.message = '';

      this.deleteProperty(this.currentProperty)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltProperty',
          data: this.currentProperty
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Property", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Property.pdf')
      }
    },

    NewHolder(item) {
      item.push(
        {
          HolderID: null,
        }
      )
    },

    removeHolder(item, parent) {
      const index = parent.findIndex(p => p.HolderID === item.HolderID);
      parent.splice(index, 1)
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedProperties = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.property.def = {},
      this.property.holders = [],
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.property.def = {},
      this.property.holders = [],
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    close () {
      this.rejectionDialog = false
      this.RejectionStatus = 0
    },

    setActiveProperty (item, index) {
      this.currentProperty = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isProperties().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedProperties", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
